import { InputHTMLAttributes, Ref } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
  ref?: Ref<HTMLInputElement>;
}

export const Input = (props: Props) => {
  const { className, wrapperClassName, ref, ...rest } = props;

  return (
    <div className={twMerge('relative', wrapperClassName)}>
      <input
        className={twMerge(
          'border-neutral-700',
          'border',
          'h-10',
          'outline-none',
          'px-4',
          'rounded-xl',
          'text-sm',
          'text-white',
          'transition-colors',
          'w-full',
          'focus:border-neutral-300',
          'hover:border-neutral-500',
          'placeholder:text-neutral-400',
          '[&:user-invalid]:border-rose-500',
          '[&:user-invalid]:focus:border-rose-500',
          '[&:user-invalid]:hover:border-rose-300',
          className,
        )}
        ref={ref}
        style={{ backgroundColor: 'transparent' }}
        {...rest}
      />
    </div>
  );
};
